import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';

const STATUS_CONFIG = {
  pending: { label: 'Pending', color: 'default' },
  running: { label: 'Running', color: 'warning' },
  completed: { label: 'Completed', color: 'success' },
  failed: { label: 'Failed', color: 'error' },
};

function JobStatusChip({ status }) {
  const config = STATUS_CONFIG[status] || { label: status, color: 'default' };
  return <Chip label={config.label} color={config.color} size="small" />;
}

JobStatusChip.propTypes = {
  status: PropTypes.oneOf(['pending', 'running', 'completed', 'failed']).isRequired,
};

export default JobStatusChip;
